import type { HTMLAttributes } from 'react';
import { joinCss, pickCss } from '@/shared/lib/css-utils';
import css from './filter-chip.module.scss';

const styles = pickCss(css, css.root);

type FilterChipProps = HTMLAttributes<HTMLSpanElement> & {
  // The filter DSL string to render verbatim (epic #273). When empty/absent
  // the chip renders nothing.
  value?: string;
  label?: string;
};

// Read-only filter chip: shows, in monospace, the exact filter DSL the agent
// applied so the consultant can see what was filtered (epic #273, US-2).
// Click-to-edit + inline parse error are a deliberate follow-up.
export const FilterChip = ({
  value,
  label = 'Filter',
  className,
  ...restProps
}: FilterChipProps) => {
  if (!value) return null;
  return (
    <span className={styles({}, className)} title={value} {...restProps}>
      <span className={joinCss(css.rootLabel)}>{label}</span>
      <span className={joinCss(css.rootValue)}>{value}</span>
    </span>
  );
};
